export const DOWNLOAD_FROM_APPLE =
  'https://apps.apple.com/no/app/foodsteps/id1512576218?l=nb'
export const DOWNLOAD_FROM_GOOGLE =
  'https://play.google.com/store/apps/details?id=no.foodsteps.app'
